

export class GeofenceVehicleOutputWithoutStatus implements IGeofenceVehicleOutputWithoutStatus {
    /** The auto-generated id of the geofence vehicle master */
    geofence_vehicle_id!: number;
    /** The auto-generated id of the geofence master */
    geofence_id!: number;
    /** The place name with 255 character limit */
    name!: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The vehicle number with vehicle name */
    vehicle_number!: string;

    constructor(data?: IGeofenceVehicleOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geofence_vehicle_id = _data["geofence_vehicle_id"];
            this.geofence_id = _data["geofence_id"];
            this.name = _data["name"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.vehicle_number = _data["vehicle_number"];
        }
    }

    static fromJS(data: any): GeofenceVehicleOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceVehicleOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geofence_vehicle_id"] = this.geofence_vehicle_id;
        data["geofence_id"] = this.geofence_id;
        data["name"] = this.name;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["vehicle_number"] = this.vehicle_number;
        return data; 
    }
}

export interface IGeofenceVehicleOutputWithoutStatus {
    /** The auto-generated id of the geofence vehicle master */
    geofence_vehicle_id: number;
    /** The auto-generated id of the geofence master */
    geofence_id: number;
    /** The place name with 255 character limit */
    name: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The vehicle number with vehicle name */
    vehicle_number: string;
}

